module.exports = __webpack_public_path__ + "img/ios_2.105582cf.jpeg";